import { render, staticRenderFns } from "./examtypeManage.vue?vue&type=template&id=ecf014a6&"
import script from "./examtypeManage.vue?vue&type=script&lang=js&"
export * from "./examtypeManage.vue?vue&type=script&lang=js&"
import style0 from "./examtypeManage.vue?vue&type=style&index=0&id=ecf014a6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports